export const stripInvisibleChars = str => str.replace(/[\u200B-\u200D\uFEFF\u00A0]/g, '').trim();
